import { CameraIcon } from "@heroicons/react/24/outline";
import { SecondaryButton } from "components/ui/secondary-button";
import React, { useCallback } from "react";
import { navigate } from "store/actions";
import { useFeature } from "store/selectors/hooks";

export const ScanBusinessCardButton: React.FC = () => {
    const enabled = useFeature("businessCardScan");

    const handleClick = useCallback(() => {
        navigate("/references/scan-business-card");
    }, []);

    if (!enabled) {
        return null;
    }

    return (
        <SecondaryButton onClick={handleClick}>
            <div className="flex items-center md:space-x-2">
                <CameraIcon className="w-5 h-5" />
                <span className="text-sm max-md:hidden">Scan business card</span>
            </div>
        </SecondaryButton>
    );
};
